// ─────────────────────────────────────────────────────────
//  Constantes de routes — évite les strings en dur partout
// ─────────────────────────────────────────────────────────

export const ROUTES = {
  // Auth
  LOGIN:            '/login',
  FORGOT_PASSWORD:  '/forgot-password',
  RESET_PASSWORD:   '/reset-password',
  TWO_FACTOR:       '/two-factor',
  ACCEPT_INVITE:    '/invite/accept',

  // App
  DASHBOARD:        '/dashboard',

  // Comptabilité
  ACCOUNTING:             '/accounting',
  ACCOUNTING_ENTRIES:     '/accounting/entries',
  ACCOUNTING_LEDGER:      '/accounting/ledger',
  ACCOUNTING_BALANCE:     '/accounting/balance',
  ACCOUNTING_REPORTS:     '/accounting/reports',
  ACCOUNTING_BUDGET:      '/accounting/budget',

  // Trésorerie
  TREASURY:               '/treasury',
  TREASURY_RECONCILIATION: '/treasury/reconciliation',
  TREASURY_FORECAST:      '/treasury/forecast',

  // RH
  HR:                     '/hr',
  HR_EMPLOYEES:           '/hr/employees',
  HR_EMPLOYEE_DETAIL:     '/hr/employees/:id',
  HR_CONTRACTS:           '/hr/contracts',
  HR_PAYROLL:             '/hr/payroll',
  HR_PAYSLIPS:            '/hr/payroll/payslips',
  HR_LEAVES:              '/hr/leaves',
  HR_LEAVE_CALENDAR:      '/hr/leaves/calendar',
  HR_ATTENDANCE:          '/hr/attendance',
  HR_CONFIG:              '/hr/config',
  HR_DECLARATIONS:        '/hr/payroll/declarations',

  // Carrière
  CAREER:                 '/career',
  CAREER_EVALUATIONS:     '/career/evaluations',
  CAREER_TRAININGS:       '/career/trainings',

  // CRM
  CRM:                    '/crm',
  CRM_PIPELINE:           '/crm/pipeline',
  CRM_CONTACTS:           '/crm/contacts',
  CRM_COMPANIES:          '/crm/companies',
  CRM_ACTIVITIES:         '/crm/activities',
  CRM_TARGETS:            '/crm/targets',
  CRM_COMMISSIONS:        '/crm/commissions',
  CRM_LEADERBOARD:        '/crm/leaderboard',
  CRM_SEQUENCES:          '/crm/sequences',
  CRM_COMMISSION_PLANS:   '/crm/commission-plans',  // ← Bloc F
  CRM_ANALYTICS:          '/crm/analytics',
  CRM_PIPELINE_CONFIG:    '/crm/pipeline/config',
  CRM_OPPORTUNITY_DETAIL: '/crm/opportunities/:id',

  // Projets
  PROJECTS:               '/projects',
  PROJECT_DETAIL:         '/projects/:id',
  PROJECT_BOARD:          '/projects/:id/board',
  PROJECT_GANTT:          '/projects/:id/gantt',  // ← Bloc C

  // Chat
  CHAT:                   '/chat',
  CHAT_CHANNEL:           '/chat/:channelId',

  // Documents
  DOCUMENTS:              '/documents',
  DOCUMENTS_SHARED:       '/documents/shared',
  DOCUMENT_DETAIL:        '/documents/:id',

  // Réunions
  MEETINGS:               '/meetings',
  MEETING_DETAIL:         '/meetings/:id',

  // Organigramme
  ORGCHART:               '/orgchart',

  // Tickets
  TICKETS:                '/tickets',
  TICKET_DETAIL:          '/tickets/:id',

  // Admin
  ADMIN:                  '/admin',
  ADMIN_USERS:            '/admin/users',
  ADMIN_ROLES:            '/admin/roles',
  ADMIN_PERMISSIONS:      '/admin/permissions',
  ADMIN_AUDIT:            '/admin/audit',
  ADMIN_SETTINGS:         '/admin/settings',

  // Profil
  PROFILE:                '/profile',

  // Pointage Enrichi (M9)
  ATTENDANCE_ENRICHED:    '/attendance-enriched',
} as const

export type RouteKey = keyof typeof ROUTES
export type RoutePath = (typeof ROUTES)[RouteKey]

// Helper pour les routes avec paramètres
export const buildRoute = (route: string, params: Record<string, string>): string => {
  return Object.entries(params).reduce(
    (acc, [key, value]) => acc.replace(`:${key}`, value),
    route,
  )
}
